import React, { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { Box, IconButton, InputAdornment ,InputBase,makeStyles} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { queryStringToObj } from "../../../../Utility"; 

const useStyles = makeStyles((theme) => ({
  searchContainer: {
    display: "flex",
    alignItems: "center",
    backgroundColor: theme?.agentTheme?.card?.main,
    borderRadius: "50px",
    maxWidth: "280px",
    width: "100%",
    height: "52px",
    marginLeft: "20px",
    position: "relative",
    overflow: "hidden",
    transition: "border 0.3s ease",
    border: "2px solid transparent",
    boxShadow: "inset 0 0 2px rgba(0,0,0,0.05)",

    "&:focus-within": {
      border: `1px solid ${theme?.agentTheme?.primary?.main}`,
      transition: "border 0.3s ease",
    },
  },

  inputRoot: {
    color: theme?.agentTheme?.card?.foreground,
    flex: 1,
    height: "100%",
    paddingLeft: "18px",
  },

  inputInput: {
    fontSize: "15px",
    paddingRight: "50px",
    "&::placeholder": {
      color: theme?.agentTheme?.card?.foreground,
      opacity: 0.5,
      transition: "opacity 0.3s ease",
    },
    "&:focus::placeholder": {
      opacity: 0,
    },
  },

  searchButton: {
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    background: theme?.agentTheme?.primary?.main,
    border: "none",
    width: "52px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: theme?.agentTheme?.primary?.foreground,
    boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
    transition: "background 0.3s ease",
    "&:hover": {
      background:theme?.agentTheme?.secondary?.main,
      color: theme?.agentTheme?.secondary?.foreground,
    },
  },
}));

const SearchBar = ({ username = null, placeholder = "Search" }) => {
  const classes = useStyles();
  const [searchVal, setSearchVal] = useState("");
  const location = useLocation();
  const searchParams = queryStringToObj(location.search);

  useEffect(() => {
    setSearchVal(searchParams.q || "");
  }, [location.search]);

  const handleSearch = () => {
    if (searchVal?.trim()) {
      const query = `?&q=${encodeURIComponent(searchVal)}`;
      window.location = username
        ? `/${username}/packages/${query}`
        : `/packages/${query}`;
    }
  };

  const keyPress = (e) => {
    if (e.key === "Enter") handleSearch();
  };

  return (
    <Box className={classes.searchContainer}>
      <InputBase
        placeholder={placeholder}
        classes={{
          root: classes.inputRoot,
          input: classes.inputInput,
        }}
        value={searchVal}
        onChange={(e) => setSearchVal(e.target.value)}
        onKeyDown={keyPress}
        inputProps={{ "aria-label": "search" }}
        endAdornment={
          <InputAdornment position="end">
            <IconButton onClick={handleSearch}>
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        }
      />
      <button className={classes.searchButton} onClick={handleSearch}>
        <SearchIcon style={{ fontSize: "24px" }} />
      </button>
    </Box>
  );
};

export default SearchBar;
